import { render, staticRenderFns } from "./model-panel.vue?vue&type=template&id=54c1902c&scoped=true"
import script from "./model-panel.vue?vue&type=script&lang=ts"
export * from "./model-panel.vue?vue&type=script&lang=ts"
import style0 from "./model-panel.vue?vue&type=style&index=0&id=54c1902c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c1902c",
  null
  
)

export default component.exports